import {Component, Inject} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {SharedModule} from '../../../../../shared/shared.module';
import {Location, NgClass, NgIf, NgSwitch, NgSwitchCase} from '@angular/common';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthResponse, Register} from '../../../auth.model';
import {AuthService} from '../../../service/auth.service';
import {GeneralResponse} from '../../../../parametre/parametre.model';
import {ModalDismissReasons, NgbModal, NgbModalConfig} from '@ng-bootstrap/ng-bootstrap';
import {ModalComponent, NgbdModalContent} from '../../../../../components/modal/modal.component';
import {environment} from '../../../../../../environments/environment';
import {NgxSpinnerComponent, NgxSpinnerService} from 'ngx-spinner';
import {ToasterService} from '../../../../../globalServices/toaster.service';

@Component({
  selector: 'app-register-step2',
  standalone: true,
  imports: [
    RouterLink,
    SharedModule,
    NgIf,
    NgxSpinnerComponent,
    NgClass,
    NgSwitch,
    NgSwitchCase,
  ],
  templateUrl: './register-step2.component.html',
  styleUrl: './register-step2.component.scss'
})
export class RegisterStep2Component {
  isloading = false;
  // @ts-ignore
  userForm: FormGroup<Register>;
  userRegister: Register;
  typeUser: string;
  name: string;
  closeResult: string;
  public show = false;
  modal: ModalComponent;
  passwordErrors = {
    required: false,
    minLength: false,
    uppercase: false,
    lowercase: false,
    digit: false,
    specialChar: false
  };
  minLength = 8;
  passwordLength = 0;
  // tslint:disable-next-line:max-line-length
  constructor(private spinner: NgxSpinnerService,
              private location: Location, private fb: FormBuilder,
              private authService: AuthService, config: NgbModalConfig,
              private modalService: NgbModal,
              private toastr: ToasterService,
              private router: Router,
              private activeroute: ActivatedRoute) {
    this.userForm = this.fb.group({
      username: ['', Validators.required],
      telephone: ['', [Validators.required, Validators.pattern('^228[0-9]{8}$')]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required, Validators.minLength(8)],
      confirmPassword: ['', Validators.required]
    }, { validator:
      this.checkPasswords });
  }

  // tslint:disable-next-line:typedef
  checkPasswords(group: FormGroup) {
    const password = group.get('password').value;
    const confirmPassword = group.get('confirmPassword').value;
    return password === confirmPassword ? null : { notSame: true
    };
  }

  // tslint:disable-next-line:typedef
  ngOnInit() {
    this.activeroute.queryParams.subscribe(
        (params) => {
          this.typeUser = params.typeUserData;
        }
    );
  }

  onSubmit(): void {
    //console.log(' send ');
    let roleId = 1;

    this.spinner.show().then(r => r);
    //console.log(' data ');

    if (this.typeUser === environment.globals.structure){
      // @ts-ignore
      roleId = 2;
    }else {
      roleId = 1;
    }
    const registerObject = new Register(this.userForm.value.username, this.userForm.value.telephone, this.userForm.value.email, this.userForm.value.password, roleId,this.typeUser);
    this.authService.register(registerObject).subscribe(
        data => {
          let responseGeneral = new AuthResponse();
          responseGeneral = data;
          //console.log('data', this.userForm.value);
          //console.log('response', responseGeneral);
          this.isloading = false;
          if (responseGeneral.success === true){
          //  this.authService.saveToken(responseGeneral.authorisation.token);
            //console.log('token', responseGeneral.authorisation.token);

            this.spinner.hide().then(r => r);
            this.navigation(this.userForm.value.email);
          }else {
            this.spinner.hide().then(r => r);
            this.toastr.error(responseGeneral.message, "Opération réussie");

            // this.openModal();

          }
        },
        error => {
          let erreurGeneral = new GeneralResponse();
          erreurGeneral = error;
          //console.log('oops', erreurGeneral);
          this.spinner.hide().then(r => r);
          this.toastr.error(erreurGeneral.message, "Opération échouée");        }
    );
    this.isloading = false;

  }

  open(content): void {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }


  // tslint:disable-next-line:typedef
  showPassword() {
    this.show = !this.show;
  }
  back(): void {
    this.location.back();
  }
  // tslint:disable-next-line:typedef
  openModal() {
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.name = 'World';
  }
  navigation(emailData: string): void {
    this.router.navigate(['register-success'], { queryParams: {email: emailData}}).then(r => r);
  }

  validatePassword() {
    const password = this.userForm.get('password')?.value || '';
    // @ts-ignore
    this.passwordLength = password.length;

    // @ts-ignore
    this.passwordErrors.required = password.length === 0;
    // @ts-ignore
    this.passwordErrors.minLength = password.length < this.minLength;
    this.passwordErrors.uppercase = !/[A-Z]/.test(password);
    this.passwordErrors.lowercase = !/[a-z]/.test(password);
    this.passwordErrors.digit = !/[0-9]/.test(password);
    // this.passwordErrors.specialChar = !/[!@#$%^&*(),.?":{}|<>]/.test(password);
  }

// Priorité des erreurs
  errorPriority = ['required', 'minLength', 'uppercase', 'lowercase', 'digit'];

  getPriorityError(): string | null {
    for (const error of this.errorPriority) {
      if (this.passwordErrors[error]) {
        return error;
      }
    }
    return null;
  }
}
